import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetAllCountriesUseCaseInterface } from 'domain/usecases';

import { HttpStatusCode } from '../../protocols/http';

export class RemoteGetAllCountries implements GetAllCountriesUseCaseInterface {
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(): Promise<GetAllCountriesUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: 'get',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }
}
